package one.healthium.healthKit.ui

import ifaandroid.feature.healthkit.generated.resources.Res
import ifaandroid.feature.healthkit.generated.resources.ic_apple_health
import ifaandroid.feature.healthkit.generated.resources.icn_health_connect
import one.healthium.ui.compose.utils.TargetPlatform
import one.healthium.ui.compose.utils.targetPlatform
import org.jetbrains.compose.resources.DrawableResource

object ConnectBannerHelper {

    val healthKitIcon: DrawableResource = when (targetPlatform()) {
        TargetPlatform.Android -> Res.drawable.icn_health_connect
        TargetPlatform.IOS -> Res.drawable.ic_apple_health
        TargetPlatform.Web -> Res.drawable.ic_apple_health
    }

    val healthKitName: String = when (targetPlatform()) {
        TargetPlatform.Android -> "Health Connect"  // TODO loco
        TargetPlatform.IOS -> "Apple Health"
        TargetPlatform.Web -> ""
    }

    fun healthKitManageHint(appName: String): String = when (targetPlatform()) {
        TargetPlatform.Android -> "To manage your $healthKitName data with the $appName, tap Mange button below."
        TargetPlatform.IOS -> "To sync your $healthKitName data with the $appName, go to your device Settings > Apps > Health > Data Access & Devices > $appName and tap “Turn All Categories On.“."
        TargetPlatform.Web -> ""
    }
}